import {
  IsBoolean,
  IsNumber,
  IsOptional,
  IsString,
  MaxLength,
  MinLength,
} from 'class-validator';

export class UpdateSweetFaceEmployeeRequestDto {
  // @ApiProperty({
  //   description: 'Employee ID',
  //   example: 1,
  // })
  @IsNumber()
  id: number;

  // @ApiProperty({
  //   description: 'Employee first name',
  //   nullable: false,
  //   example: 'John',
  // })
  @IsString()
  @MinLength(1)
  @MaxLength(255)
  firstName: string;

  // @ApiProperty({
  //   description: 'Employee last name',
  //   nullable: false,
  //   example: 'Smith',
  // })
  @IsString()
  @MinLength(1)
  @MaxLength(255)
  lastName: string;

  // @ApiProperty({
  //   description: 'Manager PIN active boolean flag',
  //   nullable: false,
  //   example: true,
  // })
  @IsBoolean()
  managerPinActive: boolean;

  // @ApiProperty({
  //   description: 'Manager access PIN',
  //   nullable: true,
  //   example: '123456',
  // })
  @IsOptional()
  @IsString()
  @MaxLength(6)
  @MinLength(6)
  managerAccessPin: string | null;

  // @ApiProperty({
  //   description: 'Pie Merchant ID',
  //   example: 7,
  // })
  @IsNumber()
  pieMerchantId: number;
}
